import React from 'react'
import Link from 'gatsby-link'
import MediaQuery from 'react-responsive'

//SubMenus
import LocationsMenu from './LocationsMenu'
import FleetMenu from './FleetMenu'
import FleetMenuEn from './FleetMenuEn'
import ReserveMenu from './ReserveMenu'
import ServicesMenu from './ServicesMenu'


//Components
import SelectLanguage from '../components/SelectLanguage.js'

const MainNav = props => {
  return (
    <nav className="menu main-nav">
      {props.langs.map(lang => {
        if (lang.langKey == 'en' && lang.selected) {
          return (
            <ul key={lang.langKey}>
              <li>
                <Link to={`/${lang.langKey}`} onClick={props.toogle}>
                  Reservations
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <ReserveMenu lang="en" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/deals`} onClick={props.toogle}>
                  Deals
                </Link>
              </li>
              <li>
                <Link to={`/${lang.langKey}/locations`} onClick={props.toogle}>
                  Locations
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <LocationsMenu lang="en" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/fleet`} onClick={props.toogle}>
                  Fleet 
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <FleetMenuEn lang="en" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/`} onClick={props.toogle}>
                   Services
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <ServicesMenu lang="en" />
                </MediaQuery>
              </li>
            </ul>
          )
        } else if (lang.langKey == 'es' && lang.selected) {
          return (
            <ul key={lang.langKey}>
              <li>
                <Link to={`/${lang.langKey}`} onClick={props.toogle}>
                  Reserva
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <ReserveMenu lang="es" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/deals`} onClick={props.toogle}>
                  Promociones
                </Link>
              </li>
              <li>
                <Link to={`/${lang.langKey}/locations`} onClick={props.toogle}>
                  Ubicaciones
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <LocationsMenu lang="es" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/fleet`} onClick={props.toogle}>
                  Flota 
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <FleetMenu lang="es" />
                </MediaQuery>
              </li>
              <li>
                <Link to={`/${lang.langKey}/`} onClick={props.toogle}>
                Servicios
                </Link>
                <MediaQuery query="(min-width: 769px)">
                  <ServicesMenu lang="es" />
                </MediaQuery>
              </li>
            </ul>
          )
        }
      })}
    </nav>
  )
}

export default MainNav



// WEBPACK FOOTER //
// ./src/menus/MainNav.js